import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import * as api from "../../../../api/countriesApi";
import { SessionHelper } from "../../../../helpers/sessionHelper";
import ShowPersonalDetailsAsian from "./components/components/showPersonalDetailsAsian";
import EditPersonalDetails from "./components/editPersonalDetails";
import ShowPersonalDetails from "./components/showPersonalDetails";
import "./personalDetailsScreen.scss";
import "./PersonalDetailsScreenMobile.scss";
type Props = {
  user?: any;
  account: any;
  isLoading?: boolean;
};

class PersonalDetailsScreen extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      countries: [],
    };
  }

  componentDidMount() {
    this.getCountriesList();
  }

  getCountriesList = () => {
    api.fetchCountries().then(resp => {
      this.setState({
        countries: resp.countries,
      });
    });
  };

  render() {
    const isAmsAccount = this.props.account["ams"];
    const { user } = this.props;
    return (
      <div className="personal-details__component">
        {isAmsAccount ? (
          <span className="personal-details__info-user-type">
            <FormattedMessage tagName="span" id="settings-cannot-edit-user" />
          </span>
        ) : (
          ""
        )}
        {SessionHelper.isAsianSessionView() ? (
          <ShowPersonalDetailsAsian
            {...this.props.account}
            isAmsAccount={isAmsAccount}
            user={user}
          />
        ) : (
          <ShowPersonalDetails
            {...this.props.account}
            isAmsAccount={isAmsAccount}
          />
        )}
        <EditPersonalDetails
          account={this.props.account}
          countries={this.state.countries}
          isAmsAccount={isAmsAccount}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.userModel.user,
});

export default connect(mapStateToProps, null)(PersonalDetailsScreen);
